import { useEffect } from 'react';

// Llama a `onOutside` cuando se presiona el mouse fuera del elemento de `ref`.
// Solo escucha mientras `enabled` es true (ej. mientras un modal o menú está abierto).
export default function useClickOutside(ref, onOutside, enabled = true) {
  useEffect(() => {
    if (!enabled) return undefined;
    const handleMouseDown = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onOutside(event);
      }
    };
    document.addEventListener('mousedown', handleMouseDown);
    return () => document.removeEventListener('mousedown', handleMouseDown);
  }, [ref, onOutside, enabled]);
}
